var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "tenant-form",
      attrs: {
        action: "/download-document",
        name: _vm.formId,
        id: _vm.formId,
        method: "post",
        target: "_blank"
      }
    },
    [
      _c("div", { staticClass: "tenant-form__heading" }),
      _vm._v(" "),
      _c("input", {
        attrs: { name: "_token", type: "hidden" },
        domProps: { value: _vm.token }
      }),
      _vm._v(" "),
      _c("input", {
        attrs: { name: "propertyId", type: "hidden" },
        domProps: { value: _vm.property }
      }),
      _vm._v(" "),
      _c("input", {
        attrs: { name: "landlordId", type: "hidden" },
        domProps: { value: _vm.landlord }
      }),
      _vm._v(" "),
      _c("input", {
        attrs: { name: "subscriptionId", type: "hidden" },
        domProps: { value: _vm.subscription }
      }),
      _vm._v(" "),
      _c("input", {
        attrs: { name: "documentId", type: "hidden" },
        domProps: { value: _vm.document }
      }),
      _vm._v(" "),
      _vm.allowSigned
        ? _c("div", { staticClass: "tenant-form__documents mb-7" }, [
            _c("div", { staticClass: "tenant-form__documents-heading" }, [
              _vm._v(_vm._s(_vm.selectSignedCheckbox))
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "tenant-form__documents-inner" },
              [
                _vm._l(_vm.tenantInfo, function(tenantBlock, tenantIndex) {
                  return _vm._l(tenantBlock.signedCheckboxList, function(
                    checkboxSigned,
                    checkboxIndex
                  ) {
                    return _c(
                      "div",
                      { staticClass: "tenant-form__documents-row" },
                      [
                        _c("label", { staticClass: "tenant-form__checkbox" }, [
                          _c("input", {
                            attrs: {
                              type: "checkbox",
                              name: "fileId[]",
                              id:
                                _vm.formId +
                                "-" +
                                "checkbox-" +
                                tenantIndex +
                                "-" +
                                checkboxIndex +
                                "-signed",
                              disabled: checkboxSigned.disabled
                            },
                            domProps: {
                              value: checkboxSigned.id,
                              checked: checkboxSigned.value
                            },
                            on: {
                              change: function($event) {
                                checkboxSigned.value = !checkboxSigned.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "tenant-form__checkbox-indicator"
                          }),
                          _vm._v(" "),
                          !checkboxSigned.disabled &&
                          checkboxSigned.filename &&
                          checkboxSigned.filename.slice(-3).toLowerCase() ===
                            "pdf"
                            ? _c(
                                "span",
                                { staticClass: "tenant-form__checkbox-label" },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "tenant-form__gallery-link",
                                      attrs: {
                                        title: checkboxSigned.imageName,
                                        href: checkboxSigned.imageUrl,
                                        "data-rel":
                                          "lightcase:myCollection" + _vm.formId
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(checkboxSigned.checkboxText)
                                      )
                                    ]
                                  )
                                ]
                              )
                            : !checkboxSigned.disabled
                            ? _c(
                                "span",
                                { staticClass: "tenant-form__checkbox-label" },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "tenant-form__gallery-link",
                                      attrs: {
                                        title: checkboxSigned.imageName,
                                        href:
                                          "#box-" +
                                          _vm.formId +
                                          "-" +
                                          "checkbox-" +
                                          tenantIndex +
                                          "-" +
                                          checkboxIndex +
                                          "-signed",
                                        "data-rel":
                                          "lightcase:myCollection" + _vm.formId
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(checkboxSigned.checkboxText)
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _c(
                                "span",
                                { staticClass: "tenant-form__checkbox-label" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "tenant-form__checkbox-info"
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(checkboxSigned.checkboxText)
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "tenant-form__checkbox-info-inner"
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "icon-eye",
                                            on: { click: _vm.showTenantTooltip }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "tenant-form__checkbox-info-text",
                                              on: {
                                                click: _vm.showTenantTooltip
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    checkboxSigned.reason
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "tenant-form__tooltip"
                                            },
                                            [
                                              _c("div", {
                                                staticClass:
                                                  "tenant-form__tooltip-overlay",
                                                on: {
                                                  click: _vm.closeTenantTooltip
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "tenant-form__tooltip-box"
                                                },
                                                [
                                                  _c("div", {
                                                    staticClass:
                                                      "icon-close tenant-form__tooltip-close-icon",
                                                    on: {
                                                      click:
                                                        _vm.closeTenantTooltip
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "tenant-form__tooltip-text"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          checkboxSigned.reasonFullText
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "absolute" },
                            [
                              _c("v-lightcase-holder", {
                                attrs: {
                                  "image-src": checkboxSigned.imageUrl,
                                  name:
                                    "box-" +
                                    _vm.formId +
                                    "-" +
                                    "checkbox-" +
                                    tenantIndex +
                                    "-" +
                                    checkboxIndex +
                                    "-signed",
                                  "current-document": checkboxSigned,
                                  "disable-rotate": true
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ]
                    )
                  })
                })
              ],
              2
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.tenantInfo, function(tenantBlock, tenantIndex) {
        return _c("div", { staticClass: "tenant-form__tenant-box" }, [
          _c("strong", { staticClass: "tenant-form__subtitle" }, [
            _vm._v(_vm._s(tenantBlock.text))
          ]),
          _vm._v(" "),
          tenantBlock.showExtraInformation &&
          tenantBlock.extraInformations &&
          tenantBlock.extraInformations != ""
            ? _c("div", { staticClass: "mb-5" }, [
                _c("div", [
                  _c("strong", [
                    _vm._v(
                      _vm._s(
                        _vm.locales &&
                          _vm.locales.common &&
                          _vm.locales.common.extra_informations
                      )
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("em", {
                    domProps: {
                      innerHTML: _vm._s(tenantBlock.extraInformations)
                    }
                  })
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          tenantBlock.checkboxList && tenantBlock.checkboxList.length
            ? _c("div", { staticClass: "tenant-form__documents" }, [
                _c("div", { staticClass: "tenant-form__documents-heading" }, [
                  _vm._v("Documents")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "tenant-form__documents-inner" },
                  _vm._l(tenantBlock.checkboxList, function(
                    checkbox,
                    checkboxIndex
                  ) {
                    return _c(
                      "div",
                      { staticClass: "tenant-form__documents-row" },
                      [
                        _c("label", { staticClass: "tenant-form__checkbox" }, [
                          _c("input", {
                            attrs: {
                              type: "checkbox",
                              name: "fileId[]",
                              id:
                                _vm.formId +
                                "-" +
                                "checkbox-" +
                                tenantIndex +
                                "-" +
                                checkboxIndex,
                              disabled: checkbox.disabled
                            },
                            domProps: {
                              value: checkbox.id,
                              checked: checkbox.value
                            },
                            on: {
                              change: function($event) {
                                checkbox.value = !checkbox.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "tenant-form__checkbox-indicator"
                          }),
                          _vm._v(" "),
                          !checkbox.disabled &&
                          checkbox.filename &&
                          checkbox.filename.slice(-3).toLowerCase() === "pdf"
                            ? _c(
                                "span",
                                { staticClass: "tenant-form__checkbox-label" },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "tenant-form__gallery-link",
                                      attrs: {
                                        title: checkbox.imageName,
                                        href: checkbox.imageUrl,
                                        "data-rel":
                                          "lightcase:myCollection" + _vm.formId
                                      }
                                    },
                                    [_vm._v(_vm._s(checkbox.checkboxText))]
                                  )
                                ]
                              )
                            : !checkbox.disabled
                            ? _c(
                                "span",
                                { staticClass: "tenant-form__checkbox-label" },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "tenant-form__gallery-link",
                                      attrs: {
                                        title: checkbox.imageName,
                                        href:
                                          "#box-" +
                                          _vm.formId +
                                          "-" +
                                          "checkbox-" +
                                          tenantIndex +
                                          "-" +
                                          checkboxIndex,
                                        "data-rel":
                                          "lightcase:myCollection" + _vm.formId
                                      }
                                    },
                                    [_vm._v(_vm._s(checkbox.checkboxText))]
                                  )
                                ]
                              )
                            : _c(
                                "span",
                                { staticClass: "tenant-form__checkbox-label" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "tenant-form__checkbox-info"
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(checkbox.checkboxText))
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "tenant-form__checkbox-info-inner"
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "icon-eye",
                                            on: { click: _vm.showTenantTooltip }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "tenant-form__checkbox-info-text",
                                              on: {
                                                click: _vm.showTenantTooltip
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(checkbox.reason) +
                                                  "\n                  "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "tenant-form__tooltip"
                                            },
                                            [
                                              _c("div", {
                                                staticClass:
                                                  "tenant-form__tooltip-overlay",
                                                on: {
                                                  click: _vm.closeTenantTooltip
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "tenant-form__tooltip-box"
                                                },
                                                [
                                                  _c("div", {
                                                    staticClass:
                                                      "icon-close tenant-form__tooltip-close-icon",
                                                    on: {
                                                      click:
                                                        _vm.closeTenantTooltip
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "tenant-form__tooltip-text"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          checkbox.reasonFullText
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "absolute" },
                            [
                              _c("v-lightcase-holder", {
                                attrs: {
                                  "image-src": checkbox.imageUrl,
                                  name:
                                    "box-" +
                                    _vm.formId +
                                    "-" +
                                    "checkbox-" +
                                    tenantIndex +
                                    "-" +
                                    checkboxIndex,
                                  "current-document": checkbox,
                                  "disable-rotate": true
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ]
                    )
                  }),
                  0
                )
              ])
            : _c("div", { staticStyle: { color: "#ccc" } }, [
                _vm._v("No documents")
              ])
        ])
      }),
      _vm._v(" "),
      _c("div", { staticClass: "tenant-form__footer" }, [
        _vm._v("\n    " + _vm._s(_vm.downloadText) + ":\n    "),
        _c("input", {
          staticClass: "theme-btn theme-btn--small theme-btn--secondary",
          class: {
            "theme-btn--secondary-disabled": !_vm.isSomeCheckboxChecked
          },
          attrs: {
            type: "submit",
            name: "type",
            value: "PDF",
            title: "Save as pdf",
            disabled: !_vm.isSomeCheckboxChecked
          }
        }),
        _vm._v(" "),
        _c("input", {
          staticClass: "theme-btn theme-btn--small theme-btn--secondary",
          class: {
            "theme-btn--secondary-disabled": !_vm.isSomeCheckboxChecked
          },
          attrs: {
            type: "submit",
            name: "type",
            value: "ZIP",
            title: "Save as zip",
            disabled: !_vm.isSomeCheckboxChecked
          }
        }),
        _vm._v(" "),
        _c("input", {
          staticClass: "theme-btn theme-btn--small theme-btn--secondary",
          class: {
            "theme-btn--secondary-disabled": !_vm.isSomeCheckboxChecked
          },
          attrs: {
            type: "submit",
            name: "type",
            value: "PRINT",
            title: "Print",
            disabled: !_vm.isSomeCheckboxChecked
          },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.print.apply(null, arguments)
            }
          }
        }),
        _vm._v(" "),
        _c("div", [
          _c(
            "label",
            {
              staticClass: "tenant-form__checkbox",
              attrs: { for: _vm.selectAllId },
              on: { change: _vm.setStateToAllCheckboxes }
            },
            [
              _c("input", {
                attrs: {
                  type: "checkbox",
                  name: _vm.selectAllId,
                  id: _vm.selectAllId
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "tenant-form__checkbox-indicator" }),
              _vm._v(" "),
              _c("span", { staticClass: "tenant-form__checkbox-label" }, [
                _vm._v(_vm._s(_vm.selectAllCheckbox))
              ])
            ]
          )
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e84c62ee", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e84c62ee","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/VTenantForm.vue
// module id = 355
// module chunks = 1 2